import { Component, inject, input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReportControl } from '@xmedical/core';
import { ReportControlEditorService } from '../../services/report-control-editor.service';

@Component({
  selector: 'xmed-section-title-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule
  ],
  providers: [DatePipe],
  templateUrl: './section-title-renderer.component.html',
  styleUrl: './section-title-renderer.component.scss'
})
export class SectionTitleRendererComponent implements OnInit {
  private editorService = inject(ReportControlEditorService);
  private datePipe = inject(DatePipe);

  control = input.required<ReportControl>();
  value: Date = new Date();

  ngOnInit(): void {
    const ctrl = this.control();
    if (ctrl?.titleDateValue !== '') {
      this.value = new Date(ctrl.titleDateValue);
    } else {
      this.value = new Date();
      ctrl.titleDateValue = this.dateFormatter(this.value);
      this.editorService.triggerEvent();
    }
  }

  onValueChanges(date: Date): void {
    this.control().titleDateValue = this.dateFormatter(date);
    this.editorService.triggerEvent();
  }

  private dateFormatter(date: Date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd') ?? '';
  }
}
